var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.debug
        ? _c(
            "v-card",
            { staticClass: "scoring-debug" },
            [
              _c("v-card-text", [
                _vm.categories
                  ? _c(
                      "table",
                      _vm._l(_vm.categories, function(item, i) {
                        return _c("tr", { key: i }, [
                          _c("th", [_vm._v(_vm._s(item.display) + ":")]),
                          _c("td", { staticClass: "pl-2" }, [
                            _vm._v(_vm._s(item.control_value))
                          ])
                        ])
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e(),
      _c("v-data-table", {
        staticClass: "standard-table",
        attrs: {
          headers: _vm.headers,
          "items-per-page": 20,
          items: _vm.categories,
          "hide-default-footer": "",
          "disable-sort": ""
        },
        scopedSlots: _vm._u(
          [
            {
              key: "item",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c("tr", { staticClass: "standard-table-row" }, [
                    _c("td", { staticClass: "standard-table-td" }, [
                      _vm._v(_vm._s(item.display))
                    ]),
                    _c(
                      "td",
                      { staticClass: "standard-table-td" },
                      [
                        item.control_type === "txt"
                          ? _c("v-text-field", {
                              staticClass: "dynamic-input-control dense",
                              attrs: {
                                label: "Vložte hodnotu",
                                solo: "",
                                outlined: "",
                                dense: "",
                                "hide-details": ""
                              },
                              model: {
                                value: item.control_value,
                                callback: function($$v) {
                                  _vm.$set(item, "control_value", $$v)
                                },
                                expression: "item.control_value"
                              }
                            })
                          : item.control_type === "cb"
                          ? _c("v-autocomplete", {
                              staticClass: "dynamic-input-control dense",
                              attrs: {
                                items: item.children,
                                placeholder: "Zvoľte typ",
                                dense: "",
                                outlined: "",
                                "hide-details": "",
                                "item-text": "display_member",
                                "item-value": "value_member",
                                clearable: ""
                              },
                              model: {
                                value: item.control_value,
                                callback: function($$v) {
                                  _vm.$set(item, "control_value", $$v)
                                },
                                expression: "item.control_value"
                              }
                            })
                          : item.control_type === "dt"
                          ? _c("DatePicker", {
                              key: item.control_type,
                              staticClass: "mb-n8px",
                              attrs: {
                                dense: "",
                                "hide-error-icon": "",
                                placeholder: "DD/MM/YYYY"
                              },
                              model: {
                                value: item.control_value,
                                callback: function($$v) {
                                  _vm.$set(item, "control_value", $$v)
                                },
                                expression: "item.control_value"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]
              }
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }